const EMPTY = Symbol("empty");
const INVALID = Symbol("invalid");

function startOfToday() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

function parseDateOnly(value) {
  if (value == null || String(value).trim() === "") return EMPTY;

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value).trim());
  if (!match) return INVALID;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  date.setHours(0, 0, 0, 0);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return INVALID;
  }

  return date;
}

export function getDobError(value) {
  const date = parseDateOnly(value);
  if (date === EMPTY) return "Date of Birth is required";
  if (date === INVALID) return "Enter a valid date of birth";

  const today = startOfToday();
  const oldest = new Date(1900, 0, 1);
  if (date > today) return "Date of Birth cannot be in the future";
  if (date < oldest) return "Date of Birth cannot be before 1900";

  const adultCutoff = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate(),
  );
  if (date > adultCutoff) return "Driver must be at least 18 years old";

  return "";
}

export function getLicenseExpiryError(value) {
  const date = parseDateOnly(value);
  if (date === EMPTY) return "";
  if (date === INVALID) return "Enter a valid license expiry date";
  if (date < startOfToday()) {
    return "Driving license expiry date cannot be in the past";
  }
  return "";
}
